import styled from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
  height: calc(100vh - 64px);
  height: calc(100dvh - 64px);
`;

export const SidebarWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-shrink: 0;
  @media (max-width: 768px) {
    position: fixed;
    top: 64px;
    left: 0;
    height: calc(100vh - 64px);
    height: calc(100dvh - 64px);
    z-index: 1000;
    transform: translateX(${({ $isOpen }) => ($isOpen ? "0" : "-100%")});
    transition: transform 0.3s ease-in-out;
  }
`;

export const Backdrop = styled.div<{ $isOpen: boolean }>`
  display: none;
  @media (max-width: 768px) {
    display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  @media (max-width: 768px) {
    width: 100%;
  }
`;

